import React from 'react';
export var Loader = function (_a) {
    var isLoading = _a.isLoading, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (isLoading ? (React.createElement("div", { className: "loader-overlay " + className },
        React.createElement("div", { className: "loader-image" }))) : React.createElement(React.Fragment, null));
};
